module.exports = "https://img.xiyuyouxi.com/saas/img/menu2.004cb6a1.png";